export class AccionModel {
    public Id: string;
    public Observaciones: string
}